import React from 'react'
import { Typography } from '@mui/material'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from './CanvasMigrationPanel.styles'
import { CanvasMigrationLandingView } from './CanvasMigrationLandingView'
import { CanvasMigrationProgressView } from './CanvasMigrationProgressView'
import { useCanvasMigrationJob } from './useCanvasMigrationJob'

export const CanvasMigrationPanel: React.FC = () => {
  const { classes } = useStyles()
  const {
    job,
    view,
    isSubmitting,
    statusError,
    isStartDisabled,
    isRetryVisible,
    isRetryDisabled,
    handleStartMigration,
    handleRetryMigration,
  } = useCanvasMigrationJob()

  return (
    <div className={classes.root} data-testid="canvas-migration-panel">
      <div className={classes.header} data-testid="canvas-migration-header">
        <Typography className={classes.title} component="h1">
          Data Migration Console
        </Typography>
        {isRetryVisible ? (
          <div className={classes.headerActions}>
            <ButtonV2
              styleType="primary"
              disabled={isRetryDisabled}
              loading={isSubmitting}
              onClick={handleRetryMigration}
              data-testid="canvas-migration-retry"
            >
              Retry
            </ButtonV2>
          </div>
        ) : null}
      </div>

      {statusError ? (
        <Typography
          className={classes.statusError}
          data-testid="canvas-migration-status-error"
        >
          {statusError}
        </Typography>
      ) : null}

      {view === 'landing' ? (
        <CanvasMigrationLandingView
          onStart={handleStartMigration}
          isStartDisabled={isStartDisabled}
          isSubmitting={isSubmitting}
        />
      ) : (
        <CanvasMigrationProgressView job={job} />
      )}
    </div>
  )
}
